<template>
  <div>
    <!-- 귀국일 정보 -->
    <div class="marTL pf23-subTit">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">귀국일 정보</div>
    </div>

    <template v-for="(schedule, sq_code, i) in schedules">
      <SurveyReturnScheduleParticipant
        :key="`schedule_${sq_code}`"
        :activity="schedule"
        :is-first="i === 0"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SURVEY_SINGAPORE, SCHEDULE_QUESTIONS } from '@/store/actions/survey'
import SurveyReturnScheduleParticipant from './SurveyReturnScheduleParticipant.vue'
import { CommonMethodMixin } from '../mixins'

export default {
  name: 'SurveyReturnScheduleList',
  mixins: [CommonMethodMixin],
  components: {
    SurveyReturnScheduleParticipant,
  },
  computed: {
    ...mapGetters(SURVEY_SINGAPORE, {
      schedules: SCHEDULE_QUESTIONS
    }),
    scheduleCount() {
      return Object.keys(this.schedules).length;
    }
  },
}
</script>

<style scoped>
/* 모바일 화면에서 marTML으로 인해 빈 공간 생기는 현상 수정 */
@media screen and (max-width:639px) {
  .clearfix .floL.marTML, .clearfix .floR.marTML {
    margin-top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyReturnScheduleList.vue